<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.browse {
  background-color: #0d86ff;
  color: white;
}
.file {
  visibility: hidden;
  position: absolute;
}
.browse {
  background-color: #1a3665 !important;
  color: white;
}
</style>
<template>
  <div class="card pb-3">
    <div
      class="card-header bg-primary font-weight-bold text-white"
      style="display: flex; align-items: center;"
    >
      PPAK
      <Button
        class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
        @click="$router.go(-1)"
      >Kembali</Button>
    </div>
    <!-- <div class="card-header bg-white text-muted h4">Edit</div> -->
    <form id="form-data" @submit.prevent="postData">
      <div class="card-body">
        <!-- Form Tambah Sertifikasi -->

        <div class="card border-0 shadow p-2">
          <div class="card-header bg-white text-muted h4">PPAK</div>
          <div class="card-body" id="coba">
            <!-- <form> -->
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="kode" class="font-weight-bold">Kode</label>
                <input
                  type="text"
                  class="form-control"
                  id="kode"
                  required
                  v-model="formData.kodeRpl"
                  placeholder="Masukkan Kode Rpl"
                  readonly
                />
              </div>
              <div class="form-group col-md-6">
                <label for="nama" class="font-weight-bold">Nama</label>
                <input
                  type="text"
                  class="form-control"
                  id="nama"
                  required
                  v-model="formData.namaRpl"
                  placeholder="Masukkan Nama Rpl"
                />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="level" class="font-weight-bold">Level</label>
                <multiselect
                  label="namaLevel"
                  placeholder="Pilih Level"
                  @select="updateSelect"
                  v-model="modelLevelPeruntukan"
                  required
                  :options="levelPeruntukan"
                ></multiselect>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="kapasitas" class="font-weight-bold">Kapasitas</label>
                <input
                  type="number"
                  min="0"
                  class="form-control"
                  id="kapasitas"
                  placeholder="Masukkan Kapasitas"
                  v-model="formData.kapasitas"
                />
              </div>
              <div class="form-group col-md-6">
                <label for="sisa" class="font-weight-bold">Sisa</label>
                <input
                  type="text"
                  class="form-control"
                  id="sisa"
                  placeholder="Terisi Otomatis"
                  v-model="formData.sisa"
                  disabled
                />
              </div>
            </div>
            <!-- </form> -->
          </div>
        </div>
        <!-- End Form Tambah Sertifikasi -->

        <!-- Form Instruktur -->
        <div class="card border-0 shadow p-2">
          <div class="card-header bg-white text-muted h4">Instruktur RPL</div>
          <div class="card-body">
            <div class="form-row" v-for="(input,k) in formData.instrukturSertifikasiRpl" :key="k">
              <div class="form-group col-md-10">
                <label for="mata_uji" class="font-weight-bold">Instruktur</label>
                <multiselect
                  label="nama"
                  placeholder="Pilih Instruktur"
                  v-model="input.modelMultiSelect"
                  required
                  @input="(value) => pilihInstruktur(value,k)"
                  :options="instruktur"
                ></multiselect>
              </div>
              <div class="col-1 d-flex align-items-center mt-2">
                <div
                  class="btn btn-sm btn-success ml-2"
                  @click="add_instruktur(k)"
                  v-show="k == formData.instrukturSertifikasiRpl.length-1"
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </div>
                <div
                  class="btn btn-sm btn-danger ml-2"
                  @click="deleteInstruktur(input.idInstrukturSertifikasiRpl,k)"
                  v-show="k || ( !k && formData.instrukturSertifikasiRpl.length > 1)"
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Form Instruktur -->

        <!-- Form Mata Uji -->
        <div class="card border-0 shadow p-2">
          <div class="card-header bg-white text-muted h4">Daftar Mata Ujian</div>
          <div class="card-body">
            <div class="form-row" v-for="(input,k) in formData.sertifikasiRplMataUji" :key="k">
              <div class="form-group col-md-10">
                <label for="mata_uji" class="font-weight-bold">Mata Ujian</label>

                <multiselect
                  label="namaMataUji"
                  placeholder="Pilih Mata Uji"
                  v-model="input.modelMultiSelect"
                  required
                  @input="(value) => pilihMataUji(value,k)"
                  :options="mataUji"
                ></multiselect>
              </div>
            
              <div class="col-1 d-flex align-items-center mt-2">
                <div
                  class="btn btn-sm btn-success ml-2"
                  @click="add(k)"
                  v-show="k == formData.sertifikasiRplMataUji.length-1"
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </div>
                <div
                  class="btn btn-sm btn-danger ml-2"
                  @click="deleteMataUji(input.idSertifikasiRplMataUji,k)"
                  v-show="k || ( !k && formData.sertifikasiRplMataUji.length > 1)"
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Form Mata Uji -->

        <!-- Form Biaya RPL -->
        <div class="card border-0 shadow p-2">
          <div class="card-header bg-white text-muted h4">Biaya RPL</div>
          <div class="card-body">
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="biaya" class="font-weight-bold">Biaya Pendaftaran</label>
                <vue-autonumeric
                  required
                  class="form-control"
                  :options="{
                    minimumValue: '0'
                }"
                  v-model="formData.hargaPendaftaran"
                ></vue-autonumeric>
              </div>
              <div class="form-group col-md-6">
                <label for="biaya" class="font-weight-bold">Biaya Per Mata Uji</label>
                <vue-autonumeric
                  required
                  class="form-control"
                  :options="{
                      minimumValue: '0'
                  }"
                  v-model="formData.biayaPerMataUji"
                ></vue-autonumeric>
              </div>
            </div>
          </div>
        </div>
        <!-- End Form Biaya RPL -->

        <!-- Form Dokumen Upload -->
        <div class="card border-0 shadow p-2">
          <div class="card-header bg-white text-muted h4">Dokumen Persyaratan</div>
          <div class="card-body">
            <!-- <form> -->
            <div
              class="form-row"
              v-for="(input,k) in formData.dokumenPendukungSertifikasiRpl"
              :key="k"
            >
              <div class="form-group col-md-10">
                <label for="kode_dok" class="font-weight-bold">Dokumen</label>
                <multiselect
                  label="namaDokumen"
                  placeholder="Pilih Dokumen"
                  v-model="input.modelMultiSelect"
                  required
                  @input="(value) => pilihDokumen(value,k)"
                  :options="optionMasterDokumen"
                ></multiselect>
              </div>

              <div class="col-1 d-flex align-items-center">
                <div
                  class="btn btn-sm btn-success ml-2 mt-2"
                  @click="add_dok(k)"
                  v-show="k == formData.dokumenPendukungSertifikasiRpl.length-1"
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </div>
                <div
                  class="btn btn-sm btn-danger ml-2 mt-2"
                  @click="deleteDokumen(input.idDokumenPendukungSertifikasiRpl,k)"
                  v-show="k || ( !k && formData.dokumenPendukungSertifikasiRpl.length > 1)"
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </div>
              </div>
            </div>
            <!-- </form> -->
          </div>
        </div>
        <!-- End Form Dokumen Upload -->

        <!-- Form Dokumen Upload -->
        <div class="card border-0 shadow p-2">
          <div class="card-header bg-white text-muted h4">
            Dokumen Persyaratan Penerbitan Sertifikat
          </div>
          <div class="card-body">
            <!-- <form> -->
            <div
              class="form-row"
              v-for="(input, k) in formData.dokumenPersyaratanSertifikat"
              :key="k"
            >
              <div class="form-group col-md-10">
                <label for="nama_dok" class="font-weight-bold">Dokumen</label>
                <multiselect
                  label="namaDokumen"
                  placeholder="Pilih Dokumen"
                  v-model="input.modelMultiSelect"
                  required
                  @input="(value) => pilihDokumenPenerbitan(value, k)"
                  :options="optionMasterDokumen"
                ></multiselect>
                <div class="text-danger" v-if="input.invalid_dokumen">
                  Dokumen Pendukung Harus Dipilih.
                </div>
              </div>

              <div class="col-1 d-flex align-items-center">
                <div
                  class="btn btn-sm btn-success ml-2 mt-2"
                  @click="add_dok_sertifikat(k)"
                  v-show="k == formData.dokumenPersyaratanSertifikat.length - 1"
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </div>
                <div
                  class="btn btn-sm btn-danger ml-2 mt-2"
                  @click="remove_dok_sertifikat(k)"
                  v-show="
                    k ||
                    (!k && formData.dokumenPersyaratanSertifikat.length > 1)
                  "
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </div>
              </div>
            </div>
            <!-- </form> -->
          </div>
        </div>
        <!-- End Form Dokumen Upload -->
        <div class="">
          <div class="card-body pl-0">
            <div class="row">
              <CCol sm="12">
                <label for class="font-weight-bold">Status</label>
                <br />
                <div class="d-flex align-items-center">
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      class="custom-control-input"
                      name="status"
                      v-model="formData.status"
                      :value="'1'"
                      id="aktif"
                    />
                    <label class="custom-control-label" for="aktif">Aktif</label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      class="custom-control-input"
                      name="status"
                      id="tidak_aktif"
                      v-model="formData.status"
                      :value="'0'"
                    />
                    <label class="custom-control-label" for="tidak_aktif">Tidak Aktif</label>
                  </div>
                </div>
              </CCol>
            </div>
          </div>
        </div>
        <!-- End Form Dokumen Upload -->
      </div>
      <div class="card-footer bg-white border-0 mb-3 mr-3 mb-3">
        <Button
          class="btn btn-md btn-success px-4 py-2 float-right"
          type="submit"
          color="success"
        >Simpan</Button>
      </div>
    </form>
  </div>
</template>
<script>
import LevelService from "../../../../services/datamaster/level.service";

import RplWorkshopService from "../../../../services/sertifikasi/master-rpl-workshop.service";
import RplInstrukturService from "../../../../services/sertifikasi/master-rpl-instruktur.service";
import KotaKabupatenService from "../../../../services/datamaster/kota-kabupaten.service";

import RplCTAService from "../../../../services/sertifikasi/master-rpl-cta.service";
import RplRNAService from "../../../../services/sertifikasi/master-rpl-rna.service";

import SertifikasiService from "../../../../services/sertifikasi/master-sertifikasi.service";
import MasterMataUjiService from "../../../../services/sertifikasi/mata-uji.service";
import AutoNumeric from "../../../../../node_modules/autonumeric/src/main";
import VueAutonumeric from "../../../../../node_modules/vue-autonumeric/src/components/VueAutonumeric";
import baseUrl from "../../../../services/base-url";
import { AlertUtils } from "../../../../mixins/AlertUtils";
import { MasterDokumen } from "../../../../mixins/master/MasterDokumen";
import UserGraderService from "../../../../services/sertifikasi/user-grader.service";

export default {
  mixins: [AlertUtils, MasterDokumen],
  data() {
    return {
      datakotakab: [],
      KotaKab: [],
      pageSize: 10000,
      baseUrl: "",
      instruktur: [],
      option_grader: [],
      multi_kategori: [
        {
          namaLevel: "",
        },
      ],
      baseUrl: "",
      mataUji: [],

      modelLevelPeruntukan: [],
      levelPeruntukan: [],
      Level: [],

      actionPost: "",
      modelInstruktur: [
        {
          nama: "",
        },
      ],
      formData: {
        instrukturSertifikasiRplRequest: [],
        dokumenPendukungSertifikasiRplRequest: [],
        sertifikasiRplMataUjiRequest: [],
        instrukturSertifikasiRpl: [
          {
            idInstrukturRpl: "",
            idInstrukturSertifikasiRpl: "",
            nama: "",
            modelMultiSelect: [
              {
                nama: "",
              },
            ],
          },
        ],

        sertifikasiRplMataUji: [
          {
            idMasterMataUji: "",
            idSertifikasiRplMataUji: "",
            namaMataUji: "",
            deskripsi: "",
            batasNilai: "", // untuk di field
            nilaiMinimum: "", //  untuk ambil response dari API
            graderSatu: "",
            graderDua: "",
          },
        ],

        dokumenPendukungSertifikasiRpl: [
          {
            idDokumenPendukungSertifikasiRpl: "",
            kodeDokumen: "",
            namaDokumen: "",
            contohDokumen: "",
            statusUpdateFile: "",
            fileName: "",
          },
        ],
        idKotaKab: "",
        idRplWorkshop: "",
        biayaMengulang: "",
        namaRpl: "",
        hargaPendaftaran: "",
        kodeRpl: "",
        status: "",
        lokasi: "",
        tanggalDimulai: "",
        tanggalBerakhir: "",
        idLevelAnggota: "",
        idLevel: "",
        namaLevel: "",
        kategori: "",
        levelPeruntukan: "",
        biayaPerMataUji: 0,
        skpAssessment: "",
        skpNonTerstruktur: "",
        skpTerstruktur: "",
      },
    };
  },

  components: {
    VueAutonumeric,
  },

  mounted() {
    var vm = this;
    vm.baseUrl = baseUrl();
    vm.getLevel();
    vm.getMataUji();
    vm.getDetailSertifikasi();
    vm.getKotaKab();
    vm.getAllDokumen();
    vm.getInstrukturRpl("0", this.pageSize);
    vm.getDataPetugasGrader();
  },

  updated: function () {
    this.$nextTick(function () {
      var vm = this;

      vm.isiBatasNilai();
    });
  },

  methods: {
     pilihDokumenPenerbitan(value, k) {
      if(value.idMasterDokumen != null) {
        this.formData.dokumenPersyaratanSertifikat[k].invalid_dokumen = false
      }

      var data = value.idMasterDokumen;

      for (
        let index = 0;
        index < this.formData.dokumenPersyaratanSertifikat.length;
        index++
      ) {

        var idMasterDokumen = this.formData.dokumenPersyaratanSertifikat[index].idMasterDokumen;
        var idSelectMasterDokumen = data

        if (idMasterDokumen == idSelectMasterDokumen) {
          this.alertError("Tidak Boleh Ada Dokumen Yang Sama");
          return false;
        }
      }

      this.formData.dokumenPersyaratanSertifikat[k].idMasterDokumen = value.idMasterDokumen;
    },
    
    add_dok_sertifikat(index) {
      this.formData.dokumenPersyaratanSertifikat.push({
        idDokumenPendukung : "",
        idMasterDokumen : "",
        idMasterDokumenPendukung : "",
        invalid_dokumen : false,
      });
    },
    remove_dok_sertifikat(index) {
      this.formData.dokumenPersyaratanSertifikat.splice(index, 1);
    },
    getDataPetugasGrader() {
      UserGraderService.getUserGrader(0, 1000000000, "default")
        .then((response) => {
          this.option_grader = response.data.data.content;
        })
        .catch((error) => {});
    },

    pilihDokumen(value, k) {

      for (
        let index = 0;
        index < this.formData.dokumenPendukungSertifikasiRpl.length;
        index++
      ) {
        var idMasterDokumen = this.formData.dokumenPendukungSertifikasiRpl[
          index
        ].idMasterDokumen;
        var idSelectMasterDokumen = value.idMasterDokumen;
        if (idMasterDokumen == idSelectMasterDokumen) {
          this.alertError("Tidak Boleh Ada Dokumen Yang Sama");

          return false;
        }
      }

      this.formData.dokumenPendukungSertifikasiRpl[k].idMasterDokumenPendukung =
        value.idMasterDokumen;
    },

    pilihKotaKab(event) {
      var vm = this;
      vm.formData.idKotaKab = event.idKotaKab;
    },

    pilihInstruktur(value, k) {
      // comment console console.log(JSON.stringify(value));
      // comment console console.log(
        
      for (
        let index = 0;
        index < this.formData.instrukturSertifikasiRpl.length;
        index++
      ) {
        var idInstrukturRpl = this.formData.instrukturSertifikasiRpl[index]
          .idInstrukturRpl;
        var idSelectInstruktur = value.idInstrukturRpl;
        if (idInstrukturRpl == idSelectInstruktur) {
          this.alertError("Tidak Boleh Ada Instruktur Yang Sama");

          return false;
        }
      }

      this.formData.instrukturSertifikasiRpl[k].idInstrukturRpl =
        value.idInstrukturRpl;
    },

    getInstrukturRpl(currentPage, pageSize) {
      var vm = this;
      RplInstrukturService.getInstrukturRpl(currentPage, pageSize, "default")
        .then((response) => {
          vm.instruktur = response.data.data.content;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    getKotaKab() {
      var vm = this;
      KotaKabupatenService.getAll()
        .then((response) => {
          // comment console console.log(response.data.data.content);
          vm.KotaKab = response.data.data.content;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    deleteMataUji(idSertifikasiRplMataUji, index) {
      var id = idSertifikasiRplMataUji;
      // comment console console.log("idmataji" + id);
      var object = {
        id_sertifikasi_rpl_mata_uji: id,
      };
      // comment console console.log(object);

      if (object.id_sertifikasi_rpl_mata_uji == "") {
        this.remove(index);
        return false;
      } else {
        RplWorkshopService.deleteMataUji(object)
          .then((response) => {
            this.remove(index);

            // comment console console.log(response);
          })
          .catch((error) => {
            this.alertError(
              "Data Sedang Digunakan Di Modul Lain Sehingga Tidak Dapat Dihapus"
            );

            // comment console console.log(error);
          });
      }
    },

    deleteInstruktur(idInstrukturSertifikasiRpl, index) {
      var id = idInstrukturSertifikasiRpl;
      var object = {
        id_instruktur_sertifikasi_rpl: id,
      };

      // comment console console.log(object);
      if (object.id_instruktur_sertifikasi_rpl == "") {
        this.remove_instruktur(index);
      } else {
        RplWorkshopService.deleteInstruktur(object)
          .then((response) => {
            this.remove_instruktur(index);

            // comment console console.log(response);
          })
          .catch((error) => {
            this.alertError(
              "Data Sedang Digunakan Di Modul Lain Sehingga Tidak Dapat Dihapus"
            );

            // comment console console.log(error);
          });
      }
    },

    deleteDokumen(idDokumenPendukung, index) {
      // idDokumenPendukung
      var id = idDokumenPendukung;
      var object = {
        id_dokumen_pendukung_sertifikasi_rpl: id,
      };

      // comment console console.log(object);
      if (object.id_dokumen_pendukung_sertifikasi_rpl == "") {
        this.remove_dok(index);
      } else {
        RplWorkshopService.deleteDokumen(object)
          .then((response) => {
            this.remove_dok(index);

            // comment console console.log(response);
          })
          .catch((error) => {
            this.alertError(
              "Data Sedang Digunakan Di Modul Lain Sehingga Tidak Dapat Dihapus"
            );

            // comment console console.log(error);
          });
      }
    },

    isiBatasNilai() {
      var vm = this;
      /* Fungsi ini untuk menampilkan batas nilai ke form batas nilai */
      for (let i = 0; i < vm.formData.sertifikasiRplMataUji.length; i++) {
        /* Mengisi Nilai minimum ke BatasNilai berdasarkan index */
        vm.formData.sertifikasiRplMataUji[i].batasNilai =
          vm.formData.sertifikasiRplMataUji[i].nilaiMinimum;

        // document.getElementById("batas_nilai" + i).value =
        //   vm.formData.sertifikasiRplMataUji[i].batasNilai;
        // // comment console console.log(vm.formData.sertifikasiRplMataUji[i].nilaiMinimum);
      }
    },

    pilihGraderDua(value, k) {
      this.formData.sertifikasiRplMataUji[k].graderDua = value.id;
    },

    pilihGraderSatu(value, k) {
      this.formData.sertifikasiRplMataUji[k].graderSatu = value.id;
    },

    pilihMataUji(event, k) {
      var data = event.idMasterMataUji;

      for (
        let index = 0;
        index < this.formData.sertifikasiRplMataUji.length;
        index++
      ) {
        var idMasterMataUji = this.formData.sertifikasiRplMataUji[index]
          .idMasterMataUji;
        var idSelectMataUji = data;
        if (idMasterMataUji == idSelectMataUji) {
          this.alertError("Tidak Boleh Ada Mata Uji Yang Sama");

          return false;
        }
      }
      this.formData.sertifikasiRplMataUji[k].idMasterMataUji = data;

      // comment console console.log(k);
    },
    add(index) {
      this.formData.sertifikasiRplMataUji.push({
        idMasterMataUji: "",
        idSertifikasiRplMataUji: "",
        namaMataUji: "",
        deskripsi: "",
        batasNilai: "", // untuk di field
        nilaiMinimum: "", //  untuk ambil response dari API
        graderSatu: "",
        graderDua: "",
        modelGraderSatu: [],
        modelGraderDua: [],
      });

      // comment console console.log(this.formData.sertifikasiRplMataUji);
    },
    add_instruktur(index) {
      this.formData.instrukturSertifikasiRpl.push({
        idInstrukturRpl: "",
        idInstrukturSertifikasiRpl: "",
        nama: "",
      });
      // comment console console.log(this.formData.instrukturSertifikasiRpl);
    },
    add_dok(index) {
      this.formData.dokumenPendukungSertifikasiRpl.push({
        kodeDokumen: "",
        namaDokumen: "",
        contohDokumen: "",
        idDokumenPendukungSertifikasiRpl: "",
        fileName: "",
      });
      // comment console console.log(this.formData.dokumenPendukungSertifikasiRpl);
    },

    remove(index) {
      this.formData.sertifikasiRplMataUji.splice(index, 1);
    },

    remove_dok(index) {
      this.formData.dokumenPendukungSertifikasiRpl.splice(index, 1);
    },

    remove_instruktur(index) {
      this.formData.instrukturSertifikasiRpl.splice(index, 1);
    },

    getMataUji() {
      var vm = this;
      MasterMataUjiService.getAllMataUji()
        .then((response) => {
          vm.mataUji = response.data.data.content;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    getDetailSertifikasi() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });

      var vm = this;

      RplCTAService.getDetailRplCTA(this.$route.params.id_sertifikasi_rpl)
        .then((response) => {
          vm.formData.idRplWorkshop = response.data.singleData.idSertifikasiRpl;
          vm.formData = response.data.singleData;

          loader.hide();

          vm.formData.biayaPerMataUji =
            response.data.singleData.biayaPerMataUji;
          vm.formData.hargaPendaftaran =
            response.data.singleData.hargaPendaftaran;

          // comment console console.log(response);

          var namaLevel = response.data.singleData.namaLevel;
          vm.modelLevelPeruntukan = [
            {
              namaLevel: namaLevel,
            },
          ];
          vm.formData.idLevel = response.data.singleData.levelPeruntukan;
          var name = response.data.singleData.namaKotaKab;

          // comment console console.log(name);
        })
        .catch((error) => {
          loader.hide();

          // comment console console.log(error);
        });
    },

    getLevel() {
      var vm = this;
      LevelService.getAllLevel()
        .then((response) => {
          vm.levelPeruntukan = response.data.data.content;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    updateSelect(event) {
      var vm = this;
      vm.formData.idLevel = event.idLevelAnggota;
    },

    postData() {
      this.insertData(this.formData);
    },

    insertData(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });

      // comment console console.log(formData);

      for (
        let index = 0;
        index < formData.sertifikasiRplMataUji.length;
        index++
      ) {
        for (
          let indexTwo = index + 1;
          indexTwo < formData.sertifikasiRplMataUji.length;
          indexTwo++
        ) {
          if (
            formData.sertifikasiRplMataUji[index].idMasterMataUji ==
            formData.sertifikasiRplMataUji[indexTwo].idMasterMataUji
          ) {
            this.alertError("Tidak Boleh Mata Uji Yang Sama");

            return false;
          }
        }
      }

      // comment console console.log(formData);
      // comment console console.log("post");

      var vm = this;

      formData.sertifikasiRplMataUjiRequest = formData.sertifikasiRplMataUji;
      formData.instrukturSertifikasiRplRequest =
        formData.instrukturSertifikasiRpl;
      formData.dokumenPendukungSertifikasiRplRequest =
        formData.dokumenPendukungSertifikasiRpl;
      // formData.idLevel = formData.idLevelAnggota

      // comment console console.log(formData);
      RplRNAService.putRplRNA(formData)
        .then((response) => {
          loader.hide();
          vm.myModal = false;
          vm.alertSuccess();
          vm.getDetailSertifikasi();
          vm.$router.push({
            path: "/sertifikasi/master-sertifikasi-rpl/master-rpl-ppak",
          });
        })
        .catch((error) => {
          loader.hide();
          // comment console console.log(error.response);
          this.alertError(error.response.data.message);
        });
    },

    putData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });

      // comment console console.log("put");
      // comment console console.log(this.formData);

      var vm = this;
      SertifikasiService.putSertifikasi(this.formData)
        .then((response) => {
          loader.hide();
          vm.myModal = false;

          vm.alertSuccess();
        })
        .catch((error) => {
          loader.hide();
          // comment console console.log(error);

          vm.alertError();
        });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
